import { BaseMark } from '../BaseMark.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'gorgonDottedLeft';
const args = { color: CssVars.ColorGorgon };

export class GorgonDottedLeft extends BaseMark {
  constructor() {
    super(glyphname, args);
  }
}
